import { useContext } from 'react';
import { ProjectContext } from '../contexts/projectContext';

interface NavigationGroup {
  kind: string;
  title: string;
  children: Array<{
    path: string;
    title: string;
    icon?: string;
  }>;
}

const useNavigation = () => {
  const { channels } = useContext(ProjectContext);

  const groupedItems = channels.reduce((acc: any, item) => {
    const { category, path, title, pageicon } = item as any;

    let categoryGroup: any = acc.find((group: any) => group.title === category.title);

    if (!categoryGroup) {
      categoryGroup = {
        kind: 'header',
        title: category.title,
        children: [],
      };
      acc.push(categoryGroup);
    }

    categoryGroup.children.push({
      path: `/c/${path}`,
      title: title,
      icon: pageicon,
    });

    return acc;
  }, []);

  const navigation = [
    {
      path: 'home',
      title: 'Home',
    },
    {
      path: 'members',
      title: 'Members',
    },
    {
      path: '/documentation',
      title: 'Documentation',
      icon: 'explore',
    },
    ...groupedItems.filter((group: NavigationGroup) => group.title !== 'Documentation'),
  ];

  return navigation;
};

export default useNavigation;
